<template>
  <div>
    <br/>
    <el-card shadow="never">
      账号余额:
      <el-table :data="userWallet">
        <el-table-column prop="coinType" label="币种">
        </el-table-column>
        <el-table-column prop="coinAmount" label="可用">
        </el-table-column>
        <el-table-column prop="coinFroze" label="冻结">
        </el-table-column>
        <el-table-column prop="totalAmount" label="总量">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('merchantAudit', ['userWallet'])
  }
};
</script>

<style scoped lang="less">
.tag {
  margin-left: 10px;
}
</style>
